export const environment = {
  base_url: 'https://dev.service.remitall.co.uk',
  allowed_origin: 'https://dev.app.remitall.co.uk',
  // base_url: 'http://192.168.0.102:8690',
  // allowed_origin: 'http://192.168.0.102:8690',
  dataLimit: '20',
  production: false,
  envName: 'DEV'
};
